import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import {
  DIAM_API_PATH,
  DIAM_TEAM_ID,
  diamQueryKeys,
  getTeamTree,
} from '../../diamApi';
import { useApiEssentials } from '../../../../shared/hooks/useApiEssentials';
import { mapTeamTree } from './mapTeamTree';

export function useParentTeamTree(enabled: boolean) {
  const { getIdToken, apiUrl, isSignedIn } = useApiEssentials(DIAM_API_PATH);

  const teamTreeQuery = useQuery({
    queryKey: diamQueryKeys.teamTree(DIAM_TEAM_ID),
    queryFn: async () => {
      const idToken = await getIdToken();
      return getTeamTree(apiUrl, idToken, DIAM_TEAM_ID);
    },
    enabled: isSignedIn && enabled,
    retry: false,
    refetchOnWindowFocus: false,
  });

  const parentTeamTree = useMemo(
    () => mapTeamTree(teamTreeQuery.data?.teams),
    [teamTreeQuery.data],
  );

  return {
    parentTeamTree,
    isLoading: teamTreeQuery.isLoading,
    isError: teamTreeQuery.isError,
    error: teamTreeQuery.error,
  };
}
